/**
 * Whether to replace the Launch button with the Premium Run upsell.
 *
 * The upsell is a commerce affordance: it opens a "contact us about premium runs" modal. Gating it
 * on ENABLE_STRIPE keeps it absent wherever money cannot change hands, which matters because an
 * organization on a deployment that provisions no organization run environment would otherwise be
 * shown a sales pitch where its launch control belongs.
 *
 * Extracted from run.tsx so it can be tested without mounting the page.
 */
export const shouldShowPremiumRunUpsell = (params: {
  enableStripe?: boolean;
  availableEnvironmentCount?: number;
  isRunOwner: boolean;
}): boolean =>
  Boolean(params.enableStripe) &&
  !params.availableEnvironmentCount &&
  params.isRunOwner;
